module.exports = __webpack_public_path__ + "img/login1.8027a5dc.svg";